import React, {createContext, useCallback, useContext, useEffect, useReducer, useState} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import HideAppBar from "../../../widgets/header/HideAppBar";
import {
	Avatar,
	Backdrop,
	Button,
	Card, CardActionArea,
	CardActions,
	CardContent,
	CardHeader,
	CircularProgress,
	Container, Fab,
	Grid,
	Tooltip,
	Typography
} from "@mui/material";
import clsx from "clsx";
import TamponeDetailGrid from "./steps/TamponeDetailsStep";
import AccordionStep from "./utils/AccordionStep";
import {FormProvider, useForm} from "react-hook-form";
import AnagraficaStep from "./steps/AnagraficaStep";
import {useHistory, useParams} from "react-router-dom";
import {getTamponeById, resetUpdateTampone, updateTampone} from "../../../../services/TamponiServices";
import {initTamponiState, TAMPONI_INITIAL_STATE, TamponiReducer} from "../../../../reducers/TamponiReducer";
import {
	getAnagraficaById,
	resetGetAnagfrafica,
	resetGetDiario,
	setAnagraficaSuccess
} from "../../../../services/AnagraficaServices";
import {AnagraficaContext, AppContext} from "../../../../App";
import DiarioPaziente from "../../../widgets/diary/DiarioPaziente";
import { Skeleton } from '@mui/material';
import {resetAnagrafica} from "./utils/ResetUtils";
import FinalStep from "./steps/FinalStep";
import InfoLavorativeStep from "./steps/InfoLavorativeStep";
import MedicoStep from "./steps/MedicoStep";
import SintomiStep from "./steps/SintomiStep";
import RischioStep from "./steps/RischioStep";
import {initIntervistaState, INTERVISTA_INITIAL_STATE, IntervistaReducer} from "../../../../reducers/IntervistaReducer";
import QuarantenaStep from "./steps/QuarantenaStep";
import AnagraficaContattoStep from "./steps/AnagraficaContattoStep";
import {
	generateIncompletaMulti,
	resetAddIntervista,
	resetAddIntervistaIncompleta
} from "../../../../services/IntervistaServices";
import {initQuaranteneState, QUARANTENE_INITIAL_STATE, QuaranteneReducer} from "../../../../reducers/QuaranteneReducer";
import {setOpenSnackbar} from "../../../../services/AppServices";
import SVG from "react-inlinesvg";
import multiavatar from "@multiavatar/multiavatar";
import PrenotaTamponeStep from "./steps/PrenotaTamponeStep";
import IntervistaDialog from "../../../widgets/diary/utils/IntervistaDialog";
import GroupAddTwoToneIcon from '@mui/icons-material/GroupAddTwoTone';
import {AddContattoDialog} from "./utils/AddContattoDialog";
import {searchTicket} from "../../../../services/TicketServices";
import {initTicketState, TICKET_INITIAL_STATE, TicketReducer} from "../../../../reducers/TicketReducer";

export const IntervistaContext = createContext(null);
export const TamponiContext = createContext();
export const QuarantenaContext = createContext();

const IntervistaOld = () => {
	const classes = BaseStyle();
	const methods = useForm({mode: "onChange"})
	const [step, setStep] = useState(0);
	const {idTampone, idSoggetto, idFocolaio, tipoSoggetto, idTicket} = useParams();
	let history = useHistory();
	const [tamponiState, tamponiDispatch] = useReducer(TamponiReducer, TAMPONI_INITIAL_STATE, initTamponiState);
	const [intervistaState, intervistaDispatch] = useReducer(IntervistaReducer, INTERVISTA_INITIAL_STATE, initIntervistaState);
	const [quarantenaState, quarantenaDispatch] = useReducer(QuaranteneReducer, QUARANTENE_INITIAL_STATE, initQuaranteneState);
	const [ticketState, ticketDispatch] = useReducer(TicketReducer, TICKET_INITIAL_STATE, initTicketState);
	const anagraficaContext = useContext(AnagraficaContext);
	const appContext = useContext(AppContext);
	const [isAnagraficaSet, setIsAnagraficaSet] = useState(false);
	const [tipoPaziente, setTipoPaziente] = useState(tipoSoggetto ? (tipoSoggetto + ".") : "pazientezero.");
	const [numPaziente, setNumPaziente] = useState(0);
	const [submit, setSubmit] = useState(false);
	const [goBack, setGoBack] = useState(false);
	const [tags, setTags] = useState([]);
	const [openIntervista, setOpenIntervista] = useState("");
	const [openAddContatto, setOpenAddContatto] = useState(false);
	const [contatti, setContatti] = useState([]);
	const [getTicketStart, setGetTicketStart] = useState(false);
	
	const onSubmit = useCallback(() => {
		setSubmit(true);
		methods.reset({});
		resetGetAnagfrafica(anagraficaContext.dispatch);
		history.goBack();
		setSubmit(false);
	}, [history, anagraficaContext.dispatch, methods])
	
	const goBackFunction = useCallback(() => {
		if (!idTampone) {
			history.goBack();
		} else {
			if (step === 5) {
				setOpenSnackbar("warning", "Attenzione! Arrivato fino a qui devi creare l'intervista e proseguire " +
					"con lo step successivo. Tornare indietro a questo step può creare gravi problemi nella gestione del paziente!", appContext.dispatch)
			} else if (step === 6) {
				setOpenSnackbar("warning", "Attenzione! Arrivato fino a qui devi creare la quarantena o l'isolamento " +
					"a seconda del tipo di paziente e proseguire " +
					"con lo step successivo. Tornare indietro a questo step può creare gravi problemi nella gestione del paziente!", appContext.dispatch)
			} else {
				setOpenSnackbar("info", "Attenzione: Ti è stato permesso tornare alla gestione dei tamponi, tuttavia " +
					"sei caldamente invitato/a a gestire un tampone una volta aperto in quanto questo rimarrà tra i tamponi da gestire. " +
					"Usa questa funzione solo se strettamente necessario!", appContext.dispatch)
				setSubmit(true);
				resetGetAnagfrafica(anagraficaContext.dispatch);
				updateTampone({
					...tamponiState.tampone,
					active: false,
					note: tags.join(" ") + " " + (tamponiState.tampone.note ? tamponiState.tampone.note : "")
				}, tamponiDispatch);
			}
		}
	}, [tamponiState.tampone, tamponiDispatch, appContext.dispatch, step, tags, anagraficaContext.dispatch, history, idTampone])
	
	useEffect(() => {
		if (idTampone) {
			getTamponeById(idTampone, tamponiDispatch);
		} else {
			getAnagraficaById(idSoggetto, anagraficaContext.dispatch);
			setStep(1);
		}
	}, [idTampone, tamponiDispatch, idSoggetto, anagraficaContext.dispatch])
	
	useEffect(() => {
		if (idTampone && idSoggetto !== "NULL") {
			setIsAnagraficaSet(false)
			getAnagraficaById(idSoggetto, anagraficaContext.dispatch);
		}
		if (idFocolaio && idSoggetto !== "NULL") {
			setIsAnagraficaSet(false)
			getAnagraficaById(idSoggetto, anagraficaContext.dispatch);
		}
		if (idSoggetto === "NULL") {
			setAnagraficaSuccess(anagraficaContext.dispatch);
			setIsAnagraficaSet(true)
		}
	}, [idSoggetto, anagraficaContext.dispatch, idTampone, idFocolaio])
	
	useEffect(() => {
		resetAddIntervista(intervistaDispatch);
		resetAddIntervistaIncompleta(intervistaDispatch);
		resetUpdateTampone(tamponiDispatch);
		resetGetDiario(anagraficaContext.dispatch);
	}, [tipoPaziente, numPaziente, intervistaDispatch, tamponiDispatch, anagraficaContext.dispatch])
	
	useEffect(() => {
		if (!isAnagraficaSet && !anagraficaContext.state.loadingGetAnagrafica && anagraficaContext.state.errorGetAnagrafica === "") {
			setIsAnagraficaSet(true);
			if (!idFocolaio) {
				methods.reset({
					...resetAnagrafica(anagraficaContext.state.anagrafica),
				});
			}
		}
	}, [methods, anagraficaContext.state.loadingGetAnagrafica, anagraficaContext.state.errorGetAnagrafica, isAnagraficaSet, anagraficaContext.state.anagrafica, idFocolaio])
	
	useEffect(() => {
		if (idTicket) {
			setGetTicketStart(true);
			searchTicket({id: idTicket}, ticketDispatch)
		}
	}, [idTicket, ticketDispatch])
	
	useEffect(() => {
		if (getTicketStart && !ticketState.loadingSearchTicket && ticketState.errorSearchTicket === "") {
			setGetTicketStart(false);
		}
	}, [getTicketStart, ticketState.loadingSearchTicket, ticketState.errorSearchTicket])
	
	useEffect(() => {
		if (submit && !tamponiState.loadingUpdateTampone && tamponiState.errorUpdateTampone === "") {
			setSubmit(false);
			setGoBack(true);
		} else if (submit && !tamponiState.loadingUpdateTampone && tamponiState.errorUpdateTampone !== "") {
			setSubmit(false);
			setOpenSnackbar("error", tamponiState.errorUpdateTampone, appContext.dispatch);
		}
	}, [submit, tamponiState.loadingUpdateTampone, tamponiState.errorUpdateTampone, appContext.dispatch]);
	
	return (
        <React.Fragment>
            <IntervistaContext.Provider value={{state: intervistaState, dispatch: intervistaDispatch}}>
				<TamponiContext.Provider value={{state: tamponiState, dispatch: tamponiDispatch}}>
					<QuarantenaContext.Provider value={{state: quarantenaState, dispatch: quarantenaDispatch}}>
						<Backdrop open={submit} className={classes.backdrop}>
							<CircularProgress/>
						</Backdrop>
						<FormProvider {...methods}>
							<main className={classes.main}>
								<HideAppBar title={"IntervistaOld"}
								            back={!idFocolaio && (step === 0 || step === 1)} goHome={false}
								            backFunction={goBackFunction}
								            useBackOk={true} backOk={goBack}/>
								<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
									<form onSubmit={methods.handleSubmit(onSubmit)}>
										<Grid container spacing={3}>
											<Grid item xs={12} md={7}>
												<Grid container spacing={3} style={{maxHeight: "92vh", overflowY: "auto", overflowX: "hidden"}}>
													<Grid item xs={12}>
														<Card className={clsx(classes.roundBorder)}
														      style={{height: "100%", display: "flex", flexDirection: "column"}}>
															<CardHeader
																title={<Typography variant={"h6"}>
																	<b>Paziente {tipoPaziente === "pazientezero." ? "COVID POSITIVO" : tipoPaziente === "contattistretti." ? "CONTATTO STRETTO" : "CONVIVENTE"}</b>
																</Typography>} avatar={
																tamponiState.loadingGetTampone ?
																	<Skeleton variant="circular"/> :
																	tamponiState.errorGetTampone !== "" ? <Avatar>
																			<SVG src={multiavatar("idSoggetto")}/>
																		</Avatar> :
																		<Avatar>
																			<SVG src={multiavatar(idSoggetto)}/>
																		</Avatar>
															}/>
															<CardContent style={{flexGrow: 1}}>
																
																{/*TAMPONE*/}
																{tipoPaziente === "pazientezero." && idTampone &&
																	<AccordionStep step={step}
																	               withDetail={true}
																	               stepNumber={0}
																	               setStep={setStep}
																	               title={"Dettaglio tampone"}
																	               loading={tamponiState.loadingGetTampone}
																	               error={tamponiState.errorGetTampone}
																	               subtitle={<React.Fragment>Dettaglio
																		               del
																		               tampone <b>{tamponiState.tampone?.esitoTampone?.toUpperCase()}</b> del
																		               paziente: <b>{tamponiState.tampone?.codF}</b></React.Fragment>}
																	               details={<TamponeDetailGrid tags={tags} setTags={setTags}
																	                                           tampone={tamponiState.tampone}/>}
																	               actions={true}
																	/>}
																
																{/*ANAGRAFICA*/}
																{tipoPaziente === "pazientezero." &&
																	<AccordionStep step={step} stepNumber={1} setStep={setStep}
																	               title={"Anagrafica paziente"}
																	               loading={idSoggetto === "NULL" ? false : anagraficaContext.state.loadingGetAnagrafica}
																	               error={anagraficaContext.state.errorGetAnagrafica}
																	               subtitle={<React.Fragment>Anagrafica del
																		               paziente: <b>{tamponiState.tampone?.codF}</b></React.Fragment>}
																	               details={<AnagraficaStep tipoPaziente={tipoPaziente} tags={tags}
																	                                        numPaziente={numPaziente} setStep={setStep}/>}
																	/>}
																
																{tipoPaziente !== "pazientezero." &&
																	<AccordionStep step={step} stepNumber={0} setStep={setStep}
																	               title={"Anagrafica paziente"}
																	               loading={idTampone ? anagraficaContext.state.loadingGetAnagrafica : false}
																	               error={idTampone ? anagraficaContext.state.errorGetAnagrafica : ""}
																	               subtitle={<React.Fragment>Cerca o crea un'anagrafica per i
																		               contatti</React.Fragment>}
																	               details={<AnagraficaContattoStep tipoPaziente={tipoPaziente}
																	                                                setNumPaziente={setNumPaziente}
																	                                                setStep={setStep}/>}
																	/>}
																
																{/*INFO LAVORO*/}
																<AccordionStep step={step}
																               stepNumber={2}
																               setStep={setStep}
																               title={"Informazioni di carattere sociale - lavorativo"}
																               subtitle={<React.Fragment>Indica il tipo di paziente che stai
																	               intevistando
																	               (sanitario,
																	               studente, docente, operaio, ...)</React.Fragment>}
																               details={<InfoLavorativeStep setStep={setStep}/>}
																/>
																
																{/*MEDICO MMG*/}
																<AccordionStep step={step}
																               stepNumber={3}
																               setStep={setStep}
																               title={"Medico di Medicina Generale"}
																               subtitle={<React.Fragment>Cerca, crea ed assegna un medico al
																	               paziente <i>(opzionale)</i></React.Fragment>}
																               actions={false}
																               details={<MedicoStep setStep={setStep}/>}
																/>
																
																{/* SINTOMI E PATOLOGIE*/}
																<AccordionStep step={step}
																               stepNumber={4}
																               setStep={setStep}
																               title={"Sintomi e patologie"}
																               subtitle={<React.Fragment>Il paziente presenta sintomi? Ha delle
																	               patologie
																	               pregresse?</React.Fragment>}
																               actions={false}
																               details={<SintomiStep setStep={setStep}/>}
																/>
																
																{/* RISCHIO E CONTAGIO*/}
																<AccordionStep step={step}
																               stepNumber={5}
																               setStep={setStep}
																               title={"Rischio e contagio"}
																               subtitle={<React.Fragment>Il paziente è stato esposto a possibili fonti
																	               di
																	               rischio o di contagio?</React.Fragment>}
																               actions={false}
																               details={<RischioStep tipoPaziente={tipoPaziente} setStep={setStep}/>}
																/>
																
																{/*ISOLAMENTO E TAMPONE*/}
																{
																	!(tamponiState.tampone.testTipoDesc?.includes("(91.13.S)") || tamponiState.tampone.testTipoDesc?.includes("(91.13.M)")) &&
																	<AccordionStep step={step}
																	               stepNumber={6}
																	               setStep={setStep}
																	               title={"Ordinanze e tampone"}
																	               subtitle={<React.Fragment>Seleziona un' ordinanza per il paziente e
																		               decidi se prenotare un tampone</React.Fragment>}
																	               actions={false}
																	               details={<QuarantenaStep setStep={setStep}
																	                                        tipoPaziente={tipoPaziente}/>}
																	/>
																}
																
																{/*PRENOTAZIONE TAMPONE*/}
																{
																	(tamponiState.tampone.testTipoDesc?.includes("(91.13.S)") || tamponiState.tampone.testTipoDesc?.includes("(91.13.M)")) &&
																	<AccordionStep
																		step={step}
																		stepNumber={6}
																		setStep={setStep}
																		title={"Prenotazione tampone"}
																		subtitle={
																			<React.Fragment>
																				Prenota un tampone per il paziente
																			</React.Fragment>
																		}
																		details={
																			<React.Fragment>
																				<PrenotaTamponeStep idSoggetto={idSoggetto} setStep={setStep}/>
																			</React.Fragment>
																		}
																	/>
																}
																
																{/*&& !(tamponiState.tampone.testTipoDesc?.includes("(91.13.S)") || tamponiState.tampone.testTipoDesc?.includes("(91.13.M)"))*/}
																{/*CONCLUSIONE PAZIENTE "ZERO"*/}
																{(!idFocolaio) &&
																	<AccordionStep step={step}
																	               stepNumber={7}
																	               setStep={setStep}
																	               title={"Conclusione paziente caso indice"}
																	               subtitle={<React.Fragment>Ha dei contatti stretti? conviventi?
																		               Amici? <br/><b>NB: Sempre il caso indice!</b></React.Fragment>}
																	               details={<FinalStep setTipoPaziente={setTipoPaziente}
																	                                   setStep={setStep}
																	                                   setNumPaziente={setNumPaziente}/>}
																	/>}
															
															
															</CardContent>
															<CardActions className={classes.flexRight}>
																<Tooltip
																	title={idFocolaio ? "Salva e torna alle interviste incomplete" : "Salva e torna a tamponi"}>
																	<Button variant={"contained"} className={classes.roundButton} color={"primary"}
																	        style={{borderRadius: 24}}
																	        disableElevation
																	        onClick={() => {
																		        resetGetAnagfrafica(anagraficaContext.dispatch)
																		        if (idFocolaio) {
																			        history.push("/gestione/interviste")
																		        } else {
																			        if (quarantenaState.idFocolaio) {
																				        generateIncompletaMulti(contatti, intervistaDispatch, appContext.dispatch);
																			        }
																			        history.push("/gestione/tamponi")
																		        }
																	        }}>
																		<b>Ho finito! 💪</b>
																	</Button>
																</Tooltip>
															</CardActions>
														</Card>
													</Grid>
												</Grid>
											</Grid>
											<Grid item xs={12} md={5}>
												<Grid container spacing={3} style={{maxHeight: "92vh", overflowY: "auto", overflowX: "hidden"}}>
													{
														tipoPaziente !== "pazientezero." && !idFocolaio &&
														<Grid item xs={12}>
															<Card className={clsx(classes.roundPaper, classes.padding1)} style={{borderRadius: 24}}>
																<CardActionArea onClick={() => setOpenIntervista(intervistaState.intervista?.id)}>
																	<Typography color={"primary"}>
																		Clicca per visualizzare l'intervista del paziente caso indice
																	</Typography>
																</CardActionArea>
															</Card>
														</Grid>
													}
													<Grid item xs={12}>
														<DiarioPaziente
															updateDiario={step}
															showPaziente={true}
															paziente={anagraficaContext.state.anagrafica.codF}
															idSoggetto={anagraficaContext.state.anagrafica.idSoggetto ? anagraficaContext.state.anagrafica.idSoggetto : idSoggetto}/>
													</Grid>
												</Grid>
											</Grid>
										</Grid>
									</form>
								</Container>
								
								{
									openIntervista !== "" &&
									<IntervistaDialog idIntervista={openIntervista} setIntervista={setOpenIntervista}/>
								}
								
								<Fab color="primary" style={{position: "fixed", bottom: 20, right: 30}}
								     onClick={() => setOpenAddContatto(!openAddContatto)}>
									<GroupAddTwoToneIcon/>
								</Fab>
								
								{
									openAddContatto &&
									<AddContattoDialog open={openAddContatto} handleClose={setOpenAddContatto} contatti={contatti}
									                   setContatti={setContatti}/>
								}
							
							</main>
						</FormProvider>
					</QuarantenaContext.Provider>
				</TamponiContext.Provider>
			</IntervistaContext.Provider>
        </React.Fragment>
    );
};

export default React.memo(IntervistaOld)
